/* eslint-disable react/jsx-no-useless-fragment */

import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../../helpers';
import { LayoutSetup, useLayout } from '../../core';
import { Header } from './Header';
import { FullNavbar } from './FullNavbar';
import { LightNavbar } from './LightNavbar';
import { PageTitleWrapper } from '../toolbar/page-title';
import { SystemLogo } from '@/app/modules/interface-appearance/SystemLogo';

export function HeaderWrapper() {
  const { config, classes } = useLayout();

  if (config.app?.header?.default?.container === 'fluid') {
    LayoutSetup.classes.headerContainer.push('container-fluid');
  } else {
    LayoutSetup.classes.headerContainer.push('container-xxl');
  }
  if (!config.app?.header?.display) {
    return null;
  }

  return (
    <div
      className={clsx('app-header', {
        'show-page-title-mobile': !config.app.toolbar?.display,
      })}
      data-kt-sticky="true"
      data-kt-sticky-activate="{default: true, lg: true}"
      data-kt-sticky-animation="false"
      data-kt-sticky-name="app-header-minimize"
      data-kt-sticky-offset='{default: "200px", lg: "0"}'
      id="kt_app_header"
    >
      <div
        className={clsx('app-container', classes.headerContainer.join(' '), config.app.header.default?.containerClass)}
        id="kt_app_header_container"
      >
        {!!config.app.sidebar?.display && (
          <>
            {config.layoutType !== 'dark-header' && config.layoutType !== 'light-header' ? (
              <div className="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu">
                <div className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
                  <KTIcon className=" fs-1" iconName="abstract-14" />
                </div>
              </div>
            ) : null}
          </>
        )}

        {/* Show logo in header when sidebar is not displayed (header-based layouts) */}
        {!config.app.sidebar?.display && (
          <div className="d-flex align-items-center me-5">
            <Link className="d-flex align-items-center" to="/">
              <SystemLogo className="h-30px mw-250px" />
            </Link>
          </div>
        )}

        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1" id="kt_app_header_wrapper">
          {config.app.header.default?.content === 'menu' && !!config.app.header.default.menu?.display && (
            <div
              className="app-header-menu app-header-mobile-drawer align-items-stretch"
              data-kt-drawer="true"
              data-kt-drawer-activate="{default: true, lg: false}"
              data-kt-drawer-direction="end"
              data-kt-drawer-name="app-header-menu"
              data-kt-drawer-overlay="true"
              data-kt-drawer-toggle="#kt_app_header_menu_toggle"
              data-kt-drawer-width="225px"
              data-kt-swapper="true"
              data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
              data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
            >
              <Header />
            </div>
          )}
          {!config.app.toolbar?.display && <PageTitleWrapper />}
          {config.app.sidebar?.display ? <FullNavbar /> : <LightNavbar />}
        </div>
      </div>
    </div>
  );
}
